import React, { useState, useEffect } from "react";
import { FaSearch } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import { MdAdd } from "react-icons/md";
import ExpandableWithToggle from "../../../../components/BasicComponents/ExpandableWithToggle";

export default function MultiplevalueCustomList({
  columnName,
  selectedFilterValues,
  setSelectedFilters,
  dispatchUpdateItem,
  allOptions,
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedValue, setSelectedValue] = useState(selectedFilterValues);

  useEffect(() => {
    setSelectedValue(selectedFilterValues);
  }, [selectedFilterValues]);

  useEffect(() => {
    setSelectedFilters(selectedValue);
  }, [selectedValue]);

  const filteredOptions = allOptions.filter((option) => {
    if (typeof option === "string") {
      return option.toLowerCase().includes(searchTerm.toLowerCase());
    } else if (typeof option === "number") {
      return option.toString().toLowerCase().includes(searchTerm.toLowerCase());
    }
    return false;
  });

  const handleFilterClicked = (value) => {
    const newSelectedValue = selectedValue.includes(value)
      ? selectedValue.filter((v) => v !== value)
      : [...selectedValue, value];
    setSelectedValue(newSelectedValue);
    dispatchUpdateItem(newSelectedValue);
  };

  const handleTextInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleCancel = (value) => {
    const newSelectedValue = selectedValue.filter((v) => v !== value);
    setSelectedValue(newSelectedValue);
    dispatchUpdateItem(newSelectedValue);
  };

  const formatSelectedOptions = (selectedOptions) => {
    if (!Array.isArray(selectedOptions)) return "";
    return selectedOptions.join(", ");
  };

  return (
    <main className="px-1 py-1 flex flex-col overflow-y-auto w-full">
      <ExpandableWithToggle
        componentType={"ASIDE3FILTERS"}
        aside3Title={`(${formatSelectedOptions(selectedValue)})`}
      >
        <section className="w-full flex flex-col gap-1 shadow items-center justify-start rounded p-2 border-[1px]">
          <div className="flex items-center justify-center w-full">
            {/* <FaSearch className="text-gray-300" /> */}
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleTextInputChange}
              className="px-2 border rounded text-base h-7 w-full focus:outline-none font-light"
            />
          </div>
          <div
            className={`w-full ${
              filteredOptions.length <= 4 ? "h-auto" : "h-[7rem]"
            } overflow-y-auto`}
          >
            {filteredOptions.map((option, index) => (
              <div
                key={index}
                className="p-1 w-full text-left flex items-center justify-between whitespace-nowrap rounded mt-1 font-light"
              >
                <button className="w-full text-left p-2 relative group text-sm font-light">
                  {option}
                  <span className="w-auto absolute left-[0%] ml-2 hidden group-hover:block text-white bg-black shadow p-1 rounded-md text-sm z-40">
                    {option}
                  </span>
                </button>
                {selectedValue.includes(option) ? (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCancel(option);
                    }}
                  >
                    <RxCross2 className="text-black" />
                  </button>
                ) : (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleFilterClicked(option);
                    }}
                  >
                    <MdAdd />
                  </button>
                )}
              </div>
            ))}
          </div>
        </section>
      </ExpandableWithToggle>
    </main>
  );
}
